import { Logo } from "@/components/brand/Logo";
import { Skeleton } from "@/components/ui/skeleton";
import { Spinner } from "@/components/ui/spinner";

/** Skeleton for a page whose module is still loading (keeps the layout stable). */
export function PageLoading() {
  return (
    <div className="mx-auto w-full px-4 pb-16 pt-6 sm:px-6 lg:px-8 lg:pt-8" role="status" aria-label="Loading">
      <div className="space-y-2.5 pb-6">
        <Skeleton className="h-4 w-28" rounded="pill" />
        <Skeleton className="h-7 w-64" />
        <Skeleton className="h-4 w-80" />
      </div>
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {[0, 1, 2, 3].map((i) => (
          <Skeleton key={i} className="h-28" rounded="card" />
        ))}
      </div>
      <Skeleton className="mt-4 h-72 w-full" rounded="card" />
    </div>
  );
}

/** Full-screen brand splash: session probe and first router initialisation. */
export function AppLoading({ label = "Loading your workspace" }: { label?: string }) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-canvas-glow px-4" role="status" aria-label={label}>
      <Logo className="h-9" title="lean2automate AMS" />
      <div className="flex items-center gap-2.5 text-sm font-semibold text-fg-muted">
        <Spinner label="" />
        {label}
      </div>
    </div>
  );
}
